export const BRAND_NAME = process.env.REACT_APP_BRAND_NAME
export const PAYPAL_CLIENT_KEY = process.env.REACT_APP_PAYPAL_CLIENT_KEY
export const PAYPAL_CURRENCY = process.env.REACT_APP_PAYPAL_CURRENCY
// export const REFRESH_TOKEN_EXPIRY_IN_HRS = process.env.REACT_APP_REFRESH_TOKEN_EXPIRY_IN_HRS
export const REFRESH_TOKEN_EXPIRY_IN_HRS = process.env.REACT_APP_REFRESH_TOKEN_EXPIRY_IN_HRS
export const ROLE = {
    sa: 1,
    admin: 2,
    qc: 3,
    editor: 4,
    client: 5,
}
export const JOB_STATUS = {
    pending: 1,
    inprogress: 2,
    completed: 3,
    cancel_req: 4,
    cancelled: 5,
    hold: 6,
    trash: 7,
}

export const COUPON_STATUS = {
    active: 1,
    deactive: 2,
    expiry: 3,
}

export const APP_CURRENCY = {
    currency_code: process.env.REACT_APP_CURRENCY_CODE,
    currency_symbol: '$',
    // currency_symbol: process.env.REACT_APP_CURRENCY_SYMBOL,
}

export const APP_DATE_FORMAT = 'MM/DD/YYYY HH:mm A'